export const HOME = '/'
export const ABOUT = '/about'
export const SIGN_IN = '/signin'
export const VIDEO = '/video'
